/* eslint-disable quotes */
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';











const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./our-brands/our-brands.component').then(m => m.OurBrandsComponent),
    data: {
      title: 'Brands'
    }
  },
  {
    path: 'baquacil',
    loadComponent: () => import('./baquacil/baquacil.component').then(m => m.BaquacilComponent),
    data: {
      title: `Baquacil`
    }
  },
  {
    path: 'bioguard',
    loadComponent: () => import('./bioguard/bioguard.component').then(m => m.BioguardComponent),
    data: {
      title: `BioGuard`
    }
  },
  {
    path: 'freshwater',
    loadComponent: () => import('./freshwater/freshwater.component').then(m => m.FreshwaterComponent),
    data: {
      title: `Freshwater`
    }
  },
  {
    path: 'frog',
    loadComponent: () => import('./frog/frog.component').then(m => m.FrogComponent),
    data: {
      title: `Frog`
    }
  },
  {
    path: 'hot-tub-serum',
    loadComponent: () => import('./hot-tub-serum/hot-tub-serum.component').then(m => m.HotTubSerumComponent),
    data: {
      title: `Hot Tub Serum`
    }
  },
  {
    path: 'leisure-time',
    loadComponent: () => import('./leisure-time/leisure-time.component').then(m => m.LeisureTimeComponent),
    data: {
      title: `Leisure Time`
    }
  },
  {
    path: 'poolife',
    loadComponent: () => import('./poolife/poolife.component').then(m => m.PoolifeComponent),
    data: {
      title: `Poolife`
    }
  },
  {
    path: 'sirona',
    loadComponent: () => import('./sirona/sirona.component').then(m => m.SironaComponent),
    data: {
      title: `Sirona`
    }
  },
  {
    path: 'spaguard',
    loadComponent: () => import('./spaguard/spaguard.component').then(m => m.SpaguardComponent),
    data: {
      title: `SpaGuard`
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrandRoutingModule { }
